<ion-grid class="margin0">
  <ion-row>
    <ion-col (click)="click_btAmountDeposit(amout)" size="4" *ngFor="let amout of amouts">
      <button light class="button-import">{{amout.toString() | parseMoney}}</button>
    </ion-col>
  </ion-row>
</ion-grid>
